import React, { useState, useEffect } from 'react';
import { isEmpty } from "lodash"

import { CardLayout, BreadCrumb } from './containers/Layout';
import { Button, Card, Grid, Box, IconButton } from '@material-ui/core';
import { ListRounded, ListAltRounded, AddRounded } from '@material-ui/icons';

// import ListResaItem from './resaDemands/ListResaItem.jsx';
// import ListResa from './resaDemands/ListResa.jsx';
// import SingleResa from './resaDemands/SingleResa.jsx';
import Form from './resaDemands/Form.jsx';
import FormResaToSale from './resaDemands/FormResaToSale';

import Spin from '../../../commonModules/interface/Spin';
import CardPage from '../../../commonModules/layouts/CardPage';
import SingleShop from './shops/SingleShop';
import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
import AccordionFilter from './Filter/AccordionFilter';
import SingleTransferResa from './transfers/resas/SingleTransferResa';
import ListTransferResa from './transfers/resas/ListTransferResa';

const ResaDemands = (props) => {
    const [state, setState] = useState({
        view: props.new ? "new" : "list",
        listview: "sale",
        openForm: false,
        singleShop:{},
        singleResa:{
            sale:{},
            shop:{},
            client:{},
        },

        breadcrumb: "",
        currentPage: 0,
        currentPageProd: 0,
        rowsPerPage: 20,

        selectShop:"",
        searchType: "",
        searchClient: "",
        searchFacture: "",
        searchProduct: "", 
    })
        

        const normalizeStr = (str) => {// remove accent and lower case str
            if (str){
                console.log("str exist", {str}, isEmpty(str));
                str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
            }
            return str
        }
        const prodFilter = (prodID) => {
            const { PRODUCTS } = props;
            const { searchProduct } = state
    
            let product = PRODUCTS[prodID]
            let searching = searchProduct ? normalizeStr(searchProduct) : ""
    
            const productName = product ? normalizeStr(product.name) : ""
            const productRef = product ? normalizeStr(product.ref) : ""
            const productType = product ? normalizeStr(product.type) : ""
            const productBrand = product ? normalizeStr(product.marque) : ""
    
            return ( 
                productName.indexOf(searching) !== -1 ||
                productRef.indexOf(searching) !== -1 ||
                productType.indexOf(searching) !== -1 ||
                productBrand.indexOf(searching) !== -1
            )  
        }

        const handleChange = (e) => {
            const { name, value } = e.target;
            setState(prevState => ({...prevState,
                [name]: value,
                currentPage: 0,
                currentPageProd: 0,
            }))
        }
        const handleSelect = (option, name) => {
            setState(prevState => ({...prevState,
                [name]: option.value, 
                currentPage: 0,
                currentPageProd: 0,
            }))
        } 

        const getFilteredList = () => {
            const { RESAS } = props;
            const { selectShop, searchClient, searchFacture, searchType } = state;
            
            let list = Object.values(RESAS)
            // status
            var received
            if (typeof received == "boolean"){
                list = list.filter(item => item.received == received)
            }
            // client
            if (!isEmpty(searchClient)) {
                list = list.filter(item => item.client_ref === searchClient || item.sale_paygo_id === searchClient )
                // list = list.filter(item => filterClients(item))
            }
            // shop
            if(!isEmpty(selectShop)){
                list = list.filter(item => item.shop_id === selectShop)
            }
            // fact
            if(!isEmpty(searchFacture)){
                list = list.filter(item => item.id && item.id.indexOf(searchFacture.toLocaleLowerCase()) > -1)
            }
          
            return list
        }
    // CLEAR & DISPLAY
    const handleClose = () => {
        setState(prevState => ({...prevState,
                view:"list",
                breadcrumb: "",
                singleResa:{
                    sale:{},
                    shop:{},
                    client:{},
                },
            }));
            // clearForms()
        }
        const handleSingleResa = (sale, shop, client) => {
            setState(prevState => ({...prevState,
                view:"sale",
                breadcrumb:`Reservation n°${sale.id}`,
                singleResa:{sale, shop, client},
            }))
        }
        const handleResaToSale = (sale, client) => {
            setState(prevState => ({...prevState,
                view:"newSale",
                breadcrumb:`Reservation n°${sale.id}`,
                singleResa:{sale, client},
            }))
        }
        const handleSingleShop = (shop) => {
            setState(prevState => ({...prevState,
                breadcrumb: shop.name,
                singleShop:shop,
                view: "shop"
            }))
        }
        const onChangePage = (pageOfItems, page, rowsPerPage) => {
            setState(prevState => ({...prevState, currentPage:page, rowsPerPage }));
        }
        const onChangePageProd = (pageOfItemsProd, page , rowsPerPage) => {
            setState(prevState => ({...prevState, currentPageProd:page , rowsPerPage}));
        }
  
        return(
            <CardPage title="Réservations" storehouse >
                <BreadCrumb breadcrumb={ state.breadcrumb } title="Demande Réservations" back={handleClose} />
                {state.openForm &&
                    <Form
                        {...props} 
                        handleClose={ () => setState(prevState => ({...prevState, openForm: false })) } 
                    />
                }
                
                {state.view === "newSale" &&
                    <FormResaToSale
                        {...props} 
                        resa={state.singleResa.sale} 
                        client={state.singleResa.client} 
                        handleClose={ handleClose }
                    />
                }
                {state.view === "sale" &&
                    <SingleTransferResa
                        resa={state.singleResa.sale} 
                        shop={state.singleResa.shop} 
                        // client={state.singleResa.client} 
                        {...props} 
                        getPhoto={props.getPhoto} 
                    />
                }
                {state.view === "shop" &&
                    <SingleShop shop={state.singleShop} {...props} />
                }
                  
                {state.view === "list" &&
                // {state.view === "list" && (state.listview === "sale" ||  state.listview === "prodList") &&
                <>
                    <Box
                        style={{ textAlign: "center"}}
                    >
                        <Button
                            variant="contained"
                            startIcon={<AddRounded />}
                            color="primary"
                            size="large"
                            style={{ width: '60%'}}
                            onClick={ () => setState(prevState => ({...prevState, openForm: true }))}
                        >
                            Nouvelle Demande de Réservation
                        </Button>
                    </Box>
                    {/* <AccordionFilter>
                        <Grid container >
                            <Grid item xs={12} md={6}>
                                <InputSelect
                                    options={shops}
                                    value={state.selectShop}
                                    label="Sélectionner un Magasin"
                                    onChange={(option) => handleSelect(option, "selectShop") }
                                /> 
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InputSelect
                                    options={clients}
                                    value={state.searchClient}
                                    label="Client"
                                    onChange={(option) => handleSelect(option, "searchClient") }
                                /> 
                            </Grid>
                            
                            <Grid item xs={12} md={6}>
                                <InputText
                                    label="Facture"
                                    value={state.searchFacture}
                                    name="searchFacture"
                                    onChange={handleChange}
                                /> 
                            </Grid>
                            {state.listview === "prodList" &&
                            <Grid item xs={12} md={6}>
                                <InputText 
                                    name="searchProduct" 
                                    value={state.searchProduct} 
                                    placeholder="Rechercher par produit " 
                                    label="Rechercher"
                                    onChange={ handleChange} 
                                />
                            </Grid>
                            }
                        </Grid>
                    </AccordionFilter> */}
                    
                </>
                }
                {props.STATE.resas.fetching && <Spin noOverlay />}
               
                {state.view === "list" && state.listview === "sale" &&
                <Box>                    
                    {/* {!isEmpty(props.RESAS) && */}
                        <ListTransferResa
                            {...props}
                            {...state}
                            onChangePage={onChangePage}
                            handleResaToSale={handleResaToSale}  
                            handleSingleShop={handleSingleShop}  
                            handleSingleResa={handleSingleResa}  
                            getFilteredList={getFilteredList}  
                            prodFilter={prodFilter}  
                        />
                    {/* } */}
                </Box>
                }
                {/* {state.view === "list" && state.listview === "prodList" &&
                <Box> 
                    {!isEmpty(props.RESAS) &&
                        <ListResaItem
                            {...props}
                            {...state}
                            onChangePage={onChangePageProd}
                            handleSingleShop={handleSingleShop}  
                            handleSingleResa={handleSingleResa}  
                            getFilteredList={getFilteredList}  
                            prodFilter={prodFilter}  
                        />
                    }
                </Box>
                } */}
            </CardPage>
        )
}

export default ResaDemands